// extracted by mini-css-extract-plugin
export default {"container":"Container_container__s1fE1","content":"Container_content__vh+S2"};